import axios from 'axios';
import cookie from '../../cookieHelper/cookie';

// Keeps only the filters the API accepts; blank or invalid values are dropped so they don't fail validation.
export function toCompanyFilterParams(filters = {}) {
    const params = {};
    const companyName = String(filters.companyName ?? '').trim();
    const centralCompanyId = String(filters.centralCompanyId ?? '').trim();
    const custId = String(filters.custId ?? '').trim();
    if (companyName) params.companyName = companyName.slice(0, 256);
    if (/^\d+$/.test(centralCompanyId) && Number(centralCompanyId) > 0) params.centralCompanyId = Number(centralCompanyId);
    if (custId) params.custId = custId.slice(0, 128);
    return params;
}

export default async function getPurchaseCompanies(page = 0, size = 10, signal, filters = {}) {
    const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/purchases/company-dropdown`,
        {
            params: { page, size, ...toCompanyFilterParams(filters) },
            signal,
            headers: {
                Authorization: `Bearer ${cookie.getCookie(process.env.REACT_APP_COOKIE_NAME)}`,
            },
        }
    );
    const result = response.data;
    if (String(result?.status?.code) !== '10200' || !Array.isArray(result?.data?.companies)) {
        const error = new Error(result?.status?.message || 'Unable to load companies.');
        error.response = response;
        throw error;
    }
    return result.data;
}

// The dropdown endpoint supports pagination only, so collect every page before filtering.
export async function getAllPurchaseCompanies(signal) {
    const size = 100;
    const first = await getPurchaseCompanies(0, size, signal);
    const companies = [ ...first.companies ];
    for (let page = 1; page < Math.ceil(first.total / size); page += 1) {
        const result = await getPurchaseCompanies(page, size, signal);
        companies.push(...result.companies);
    }
    return { companies, total: companies.length };
}
